import React, { useMemo, useState, useEffect } from "react";
import RfmModalBase from "./RfmModalBase";

export default function RfmAddComensalModal({
  open,
  onClose,
  onAdd,
  orderOptions = [],
  preselectedOrderId = null,
}) {
  const [name, setName] = useState("");
  const [seatNumber, setSeatNumber] = useState("");
  const [orderId, setOrderId] = useState(preselectedOrderId || "");

  useEffect(() => {
    if (open) {
      setOrderId(preselectedOrderId || orderOptions?.[0]?.id || "");
      return;
    }

    setName("");
    setSeatNumber("");
    setOrderId("")
  }, [open, preselectedOrderId, orderOptions]);

  const canSubmit = useMemo(() => {
    return name.trim().length > 0 && !!orderId;
  }, [name, orderId]);


  const submit = () => {
    if (!canSubmit) return;

    onAdd?.({
      name: name.trim(),
      seat_number: seatNumber === "" ? null : Number(seatNumber),
      order_id: orderId
    });
  };

  return (
    <RfmModalBase
      open={open}
      title="Agregar Comensal"
      onClose={onClose}
      footer={
        <>
          <button className="rfm-btn rfm-btn-secondary" type="button" onClick={onClose}>
            Cancelar
          </button>
          <button className="rfm-btn rfm-btn-primary" type="button" onClick={submit} disabled={!canSubmit}>
            <i className="bi bi-plus-lg" /> Agregar
          </button>
        </>
      }
    >
      <div className="rfm-form-group">
        <label className="rfm-form-label">Orden</label>
        <select
          className="rfm-form-input"
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
        >
          <option value="">Seleccione una orden</option>
          {orderOptions.map((ord) => (
            <option key={ord.id} value={ord.id}>
              {ord.label}
            </option>
          ))}
        </select>
      </div>

      <div className="rfm-form-group">
        <label className="rfm-form-label">Nombre</label>
        <input
          className="rfm-form-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ej: Cliente 1, Juan..."
        />
      </div>

      <div className="rfm-form-group">
        <label className="rfm-form-label">Asiento</label>
        <input
          className="rfm-form-input"
          type="number"
          min="1"
          value={seatNumber}
          onChange={(e) => setSeatNumber(e.target.value)}
          placeholder="Opcional"
        />
      </div>
    </RfmModalBase>
  );
}
